<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">
      {{ letter.selectPayment }}
    </template>
    <template slot="select-content">
      <List class="payment-select-container j-payment-select-container">
        <ListItem
          class="areas-lst select-items"
          type="paymentItem"
          :active="price.TRANS_AMOUNT == curPrice.TRANS_AMOUNT"
          @click="selectPrice(price)"
          v-for="(price, index) in pricesList"
          :key="index"
        >
          <em class="payment-sleect-icon select-money-icon"></em>
          {{ price.TRANS_AMOUNT }}
          {{ curPayType ? curPayType.show_currency : '' }}
          =
          <template v-if="+price.COIN">
            {{ parseInt(price.COIN) }}{{ directPayCoinName }}
          </template>
          <template v-if="+price.EXTRA_COIN">
            + {{ parseInt(price.EXTRA_COIN) }}{{ directPayExtraCoinName }}
          </template>
          <span class="type-discount" v-if="price.EXTRA_RATIO">
            {{ letter.gainPlus }}
            {{ ~~(price.EXTRA_RATIO * 100) }}%
          </span>
        </ListItem>
      </List>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialStore/selectContainer';
import { getCoinName } from '../../../store/store/storager';
export default {
  name: 'bankPayment',
  data() {
    return {
      coinName: getCoinName()
    };
  },
  props: [
    'pricesList',
    'curPrice',
    'curPayType',
    'directPayCoinName',
    'directPayExtraCoinName'
  ],
  mixins: [selectContainer],
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    selectPrice(price) {
      this.$emit('selectPrice', price);
    }
  }
};
</script>
<style lang="scss" scoped>
.payment-select-container {
  padding-bottom: 80px;
}
.type-discount {
  height: 26px;
  margin: auto 12px;
}
.select-items {
  align-items: center;
  line-height: 50px;
}
@media screen and (orientation: landscape) {
  .select-items {
    line-height: 80px;
  }
}
</style>
